import React from 'react';
import styled from '@emotion/styled';

import { BottomSheetInfo } from '../../services/usePaymentService';
import { PaymentBottomSheetInfo } from './PaymentBottomSheetInfo';

interface Props {
  bottomSheetInfo: BottomSheetInfo[];
}

export const PaymentBottomSheet: React.FC<React.PropsWithChildren<Props>> = ({ bottomSheetInfo }) => {
  return (
    <BottomSheet>
      <PaymentBottomSheetInfo bottomSheetInfo={bottomSheetInfo} />
    </BottomSheet>
  );
};

const BottomSheet = styled.div`
  padding: 16px;
`;
